import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../core/service/common-service/common.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatSort, MatPaginator, MatSelect, MatOption } from '@angular/material';
import { DatePipe } from '@angular/common';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { kpiCustData } from './kpiCustData';
import * as _moment from 'moment';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { ToastrService } from 'ngx-toastr';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
})

export class ReportingComponent {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('filterSelect', { static: true }) filterSelect: MatSelect;
  @ViewChild('allSelected', { static: true }) private allSelected: MatOption;

  searchValue: FormControl = new FormControl();

  displayedColumns: string[] = [
    'bookingId',
    'customerName',
    'inbound',
    'duaDate',
    'workshopName',
    'serviceType',
    'subProcess',
    'contactNo',
    'registrationNo',
    'chassisNo',
    'modelDescription',
    'leadGenerationDate',
    'noOfAttempts',
    'noOfContact',
    'lastContacted',
    'noOfBooking',
    'lastBooking',
    'bayNo',
    'leadStatus',
    'conversionStatus',
    'cstAppBookingId',
    'sourceId',
    'appStatus'
  ];

  selectWorkshop: FormGroup;
  dataSource: any;
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  isDateRangeInvalid = false;
  toDatenew: Date = new Date();
  fromDatenew: Date = new Date();
  toDateUsr: Date = new Date();
  fromDateUsr: Date = new Date();
  spinner: boolean;
  userId: string;
  userInfo: any;
  filterValues: string[] = [];
  workshopcodeFilter: string;
  workshopFilter: string;
  workshopcode: string;
  splitworkshopcode: string[] = [];
  selectedFilter: string[] = [];
  HideGrid: boolean = true;
  dataGridArray: kpiCustData[] = [];
  wsCodeFilter: string;
  clear: boolean;
  maxDate: Date = new Date();
  selectedReportType: string;
  reportTypeValues: any[] = ['ALL', 'Booking'];
  filterValuesCopy: string[] = [];
  selectedDealer:any;
  dealerCode: string[] = [];
  userRole: any;
  smeRole: boolean = true;
  panRole: boolean = true;
  rsmRole: boolean = true;
  otherRole: boolean = true;
  dataGridSize: number = 0;

  constructor(private datePipe: DatePipe, private toastr: ToastrService,
     public dialog: MatDialog, private commonService: CommonService,
     private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.setDefaultDates();
    this.userId = localStorage.getItem('userId');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userRole=localStorage.getItem('userRoles');
    let days=this.getDays();
    if(days==30)
    this.fromDateUsr= moment().add(-30,'d').set({hours:0, minutes:0, seconds:0 , milliseconds:0})
    else
    this.fromDateUsr= moment().add(-31,'d').set({hours:0, minutes:0, seconds:0 , milliseconds:0})
    this.toDateUsr.setDate(this.today.getDate() + 15);
    if (this.userRole == "SME") {
      this.smeRole = false;
    } else if (this.userRole == "Pan India") {
      this.panRole = false;
    } else if (this.userRole == "Regional Service Manager") {
      this.rsmRole = false;
    } else {
      this.otherRole = false;
    }
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.selectWorkshop = this.fb.group({
      workshopCodeType: new FormControl(this.filterValues),
      selectedDealer: ['']
    });
    if(this.userRole=="CRE" || this.userRole== "Pan India"){
      this.selectedReportType = this.reportTypeValues[0];
    }
    else{
      this.selectedReportType=""
    }
    //this.selectedFilter = this.filterValues;
    //this.minDate.setDate(this.toDate.getDate()-30);
    this.workshopCodeFilter();
  }

  /**
  * Name: getDays
  * purpose: to get number of Days in previous month
  */
  getDays(){
    let month =this.today.getMonth();
    let year = this.today.getFullYear();
    return new Date(year, month, 0).getDate();

  }

  /**
  * Name: getprocessreport
  * purpose: To export report as excel
  */
  getprocessreport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let fileName = "SRM_Data Status Report_From_" + fdate + "_To_" + tdate;
    let roleId = this.userInfo['0'].roleId || '1';
    this.applyfilter();
    this.commonService.getprocessreport(fdate, tdate, this.userId, roleId, this.wsCodeFilter)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

    /**
  * Name: getLostCustomerProcessReport
  * purpose: To export report as excel
  */
     getLostCustomerProcessReport(): void {
      if (this.isDateRangeInvalid) {
        this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
        return;
      }
      this.spinner = true;
      let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
      let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
      let fileName = "LCRM_data_status_report_from_" + fdate + "_to_" + tdate;
      let roleId = this.userInfo['0'].roleId || '1';
      this.applyfilter();
      this.commonService.getLostCustomerProcessReport(fdate, tdate, this.userId, roleId, this.wsCodeFilter)
        .subscribe(fileData => {
          if (fileData) {
            const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement("a");
            if (link.download !== undefined) {
              let url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.spinner = false;
            }
          } else {
            this.spinner = false;
          }
        }, err => {
          this.spinner = false;
        });
    }
/**
  * Name:  getVisitFormReport
  * purpose: To export vist form report as excel
  */
    getVisitFormReport(){
      if (this.isDateRangeInvalid) {
        this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
        return;
      }
      this.spinner = true;
      let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
      let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
      let fileName = "Vist_Form_status_report_from_" + fdate + "_to_" + tdate;
      let roleId = this.userInfo['0'].roleId || '1';
      this.applyfilter();
      this.commonService.getLostVisitFormReport(fdate, tdate, this.userId, roleId, this.wsCodeFilter)
        .subscribe(fileData => {
          if (fileData) {
            const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement("a");
            if (link.download !== undefined) {
              let url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.spinner = false;
            }
          } else {
            this.spinner = false;
          }
        }, err => {
          this.spinner = false;
        });

    }

  /**
  * Name: prepairCallList
  * purpose: To prepare call list for dataGrid
  */
  prepairCallList(): void {
    this.spinner = true;
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let roleId = this.userInfo['0'].roleId || '1';
    let reportTyp = "";
    if(this.selectedReportType != "ALL"&& this.userRole=="CRE") {
      reportTyp = "B"
    } else {
      reportTyp=""
    }
    this.applyfilter();
    this.commonService.dataGrid(this.userId, roleId, startdate, enddate, this.wsCodeFilter, reportTyp)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            this.HideGrid = false;
            this.dataSource = new MatTableDataSource<kpiCustData>(res['responseData']['gridEntityList']);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: workshopCodeFilter
  * purpose: To get workshop code filter
  */
  workshopCodeFilter(): void {
    this.filterValues = [];
    this.workshopcodeFilter;
    this.splitworkshopcode = [];
    this.workshopFilter;
    this.workshopcode;
    let roleId = this.userInfo['0'].roleId || '1';
    this.commonService.workshopFilter(this.userId, roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            res['responseData'].forEach(data => {
              this.workshopcodeFilter = data.workshop;
              this.workshopcode = (this.workshopcodeFilter.split(" ", 1)).toString();
              this.splitworkshopcode.push(this.workshopcode);
              this.filterValues.push(this.workshopcodeFilter);
            });
            //this.selectedFilter = this.filterValues;
            this.workshopFilter = this.splitworkshopcode.toString();
            this.filterValuesCopy = this.filterValues;
            //this.prepairCallList();
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  tosslePerOne(all){
    if (this.allSelected.selected) {
     this.allSelected.deselect();
     return false;
    }
    if(this.selectWorkshop.controls.workshopCodeType.value.length==this.filterValues.length)
      this.allSelected.select();
  }

  /**
  * Name: toggleAllSelection
  * purpose: To select/remove all data in workshop drop down
  */
 toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.selectWorkshop.controls.workshopCodeType.patchValue([...this.filterValues,0]);
    } else {
      this.selectWorkshop.controls.workshopCodeType.patchValue([]);
    }
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /**
   * Name: apply
   * purpose: To apply filter on datagrid
   */
  apply(): void {
    this.spinner = true;
    this.dataSource = '';
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let roleId = this.userInfo['0'].roleId || '1';
    let reportTyp = "";
    if(this.selectedReportType != "ALL" && this.userRole=="CRE") {
      reportTyp = "B"
    } else {
      reportTyp=""
     }
    this.applyfilter();
    this.commonService.dataGrid(this.userId, roleId, startdate, enddate, this.wsCodeFilter, reportTyp)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.dataSource = new MatTableDataSource<kpiCustData>(res['responseData']['gridEntityList']);
          this.dataGridSize = this.dataSource.length;
          // this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.spinner = false;
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: applyfilter
  * purpose: To select and apply the selected workshopcode
  */
  applyfilter() {
    this.wsCodeFilter = '';
    this.selectedFilter;
    this.workshopFilter;
    if (this.selectedFilter != null) {
      let splitCode = [];
      this.selectedFilter.forEach((data) => {
        if(data != '0') {
          //data.split(" - ")[0];
          splitCode.push(data.split(" - ")[0]).toString();
       }
      });
      this.wsCodeFilter = splitCode.toString();
    } else {
      this.wsCodeFilter = this.selectedFilter.toString();
    }
    //this.wsCodeFilter = this.selectedFilter.toString();
  }

  /**
  * Name: clearSearch
  * purpose: To clear search value from search box
  */
  clearSearch() {
    this.dataGridArray = [];
    this.dataSource = '';
    this.searchValue.setValue('');
    this.searchValue.enable();
    this.HideGrid = true;
    this.prepairCallList();
  }

  filterTriggered(event: any): void {
    this.today = new Date();
    if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*15))).getTime() >= this.today.getTime()){
      this.today = new Date();
      if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*15))).getTime() >= this.today.getTime()){
        this.toDate = new Date();
      } else {
         this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*15));
      }
    } else {
      this.today = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*15));
      this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*15));
    }
  }

  /**
   * Name: activeButton
   * purpose: To activat Booking Excel Report button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.selectedReportType != undefined && this.selectedReportType != 'ALL') {
      flag = true;
    }
    return flag;
  }

  /**
  * Name: getBookingReport
  * purpose: To export report as excel
  */
  getBookingReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let roleId = this.userInfo['0'].roleId || '1';
    let reportTyp = "";
    if(this.selectedReportType != "ALL"&& this.userRole=="CRE") {
      reportTyp = "B"
    } else {
      reportTyp=""
    }
    let fileName = "Booking Status Report_From_" + startdate + "_To_" + enddate;
    this.applyfilter();
    this.commonService.getBookingReport(this.userId, roleId, startdate, enddate, this.wsCodeFilter, reportTyp)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
    });
  }

  onKey() : void {
    this.filterValues = this.filterValuesCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectWorkshop.controls.selectedDealer.value;
    this.selectedDealer = this.selectedDealer.toString();
    this.dealerCode = this.filterValues.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.filterValues = [];
    this.filterValues = this.dealerCode;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     //this.selectedDealer = '';
     this.selectWorkshop.controls["selectedDealer"].setValue("");
     this.filterValues = this.filterValuesCopy;
    }
  }

  dateFilterTriggered(event: any): void {
    this.today = new Date();
    if(event.source.value == 'Booking') {
      this.today = new Date(new Date().getTime()+(1000*60*60*24*30));
    } else {
      this.today = new Date();
      this.toDate = new Date();
    }
  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('dataGridPageSize', size);
  }

  getSrmUpcomingServiceReport(): void {
      this.spinner = true;
      let fdate = this.datePipe.transform(this.fromDatenew, "yyyy-MM-dd");
      let tdate = this.datePipe.transform(this.toDatenew, "yyyy-MM-dd");
      let fileName = "SRM_Upcoming_Service_report_from_" + fdate + "_to_" + tdate;
      let roleId = this.userInfo['0'].roleId || '1';
      this.applyfilter();
      this.commonService.getSrmUpcomingServiceReport(fdate, tdate)
        .subscribe(fileData => {
          if (fileData) {
            const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement("a");
            if (link.download !== undefined) {
              let url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.spinner = false;
            }
          } else {
            this.spinner = false;
          }
        }, err => {
          this.spinner = false;
        });
    }

  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;
    this.fromDate = new Date(this.fromDate);
    this.toDate = new Date(this.toDate);
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}